var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6051 21.0437C16.3103 21.0437 16.0492 21.2433 15.9726 21.5277L2.67675 54.704V55.8647C2.67675 56.7166 2.6222 57.0254 3.33254 57.0254H55.2843C56.626 57.0254 57.8076 56.1212 58.128 54.921L69.9973 22.2044C69.9973 22.2044 69.9973 21.479 69.9973 21.0437H16.6051Z",
    fill: "#B0C3EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1323 18.7223H61.8725H63.0332V11.447C63.0332 9.69787 61.6102 8.27601 59.8622 8.27601H31.1314L25.3279 0.151123H3.5265C1.77849 0.151123 0.355469 1.57414 0.355469 3.32215V51.8347L12.2898 20.8243C12.609 19.6265 13.7906 18.7223 15.1323 18.7223Z",
    fill: "#B0C3EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderImage);
export default __webpack_public_path__ + "static/media/folder-image.cdf3dda03244c7493b54fb401a28fcaa.svg";
export { ForwardRef as ReactComponent };